import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country, NewCountry } from "src/app/domain/models/Country";
import { Routes } from "src/app/infrastructure/routes";
import { CountryGateway } from "../gateway/CountryGateway";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export class CountryService extends CountryGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getAll(): Observable<Country[]> {
    return this._http.get<Country[]>(Routes.countryApi + '/GetAll')
  }

  getById(id: number): Observable<Country> {
    throw new Error("Method not implemented.");
  }

  create(country: NewCountry): Observable<Country> {
    return this._http.post<Country>(Routes.countryApi + '/Create', country)
  }

  update(country: Country): Observable<Country> {
    throw new Error("Method not implemented.");
  }

  delete(id: number): Observable<Country> {
    throw new Error("Method not implemented.");
  }

  getAllByIsOrigin(isOrigin: boolean): Observable<Country[]> {
    return this._http.get<Country[]>(Routes.countryApi + '/GetAllByIsOrigin', {params: {isOrigin}})
  }

  getAllPaged(pageNumber: number = 1, pageSize: number= 10): Observable<PageResult<Country>> {
    return this._http.get<PageResult<Country>>(Routes.countryApi + '/GetAllPaginated', {params: {pageNumber, pageSize}})
  }
}
